import { List } from 'immutable';

import FilterFacilities from 'src/components/Filters/FilterFacilities';
import FilterFamilyWithKids from 'src/components/Filters/FilterFamilyWithKids';
import FilterSpa from 'src/components/Filters/FilterSpa';
import FilterPrices from 'src/components/Filters/FilterPrices';
import FilterRestrictions from 'src/components/Filters/FilterRestrictions';
import { getImmutableCompatible } from 'src/utils/immutableUtils';

const BOOLEAN_FILTERS = [
  ...FilterSpa.customFilters,
  ...FilterFacilities.customFilters,
  ...FilterFamilyWithKids.customFilters,
  ...FilterRestrictions.customFilters,
];

export const filterDataToURL = (filterName, filterData) => {
  if (filterName === FilterPrices.filterName) {
    return {
      filter_price_min: filterData.get('minPrice'),
      filter_price_max: filterData.get('maxPrice'),
    };
  }

  const filterParam = `filter_${filterName}`;

  if (BOOLEAN_FILTERS.indexOf(filterName) !== -1) {
    return { [filterParam]: filterData.getIn([0, 'selected']) };
  }

  if (List.isList(filterData)) {
    const paramValue = filterData
      .reduce((acc, item) => {
        const res = [...acc];

        if (getImmutableCompatible(item, 'selected')) {
          res.push(getImmutableCompatible(item, 'id'));
        }

        return res;
      }, [])
      .join(',');

    return { [filterParam]: paramValue };
  }

  if (!filterData?.get) return {};
  return { [filterParam]: filterData?.get('value') };
};

export const clearFilter = (filterName, filterData) => {
  if (filterName === FilterPrices.filterName) {
    return {
      minPrice: null,
      maxPrice: null,
    };
  }

  if (List.isList(filterData)) {
    return filterData
      .map((filterItem) => ({
        id: filterItem.get('id'),
        selected: false,
      }))
      .toJS();
  }

  return { value: null };
};
